import { ComponentStyleConfig } from '@chakra-ui/react';

export const PlaylistCover: ComponentStyleConfig = {
  baseStyle: {
    transition: 'color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    borderRadius: '4px',
  },
  sizes: {
    small: {
      width: 9,
      height: 9,
      minWidth: 9,
      minHeight: 9,
    },
    medium: {
      width: '90px',
      height: '90px',
      minWidth: '90px',
      minHeight: '90px',
    },
    big: {
      width: '128px',
      height: '128px',
      minWidth: '128px',
      minHeight: '128px',
    },
  },
  variants: {},
  defaultProps: {
    size: 'big',
  },
};
